import { string } from 'yup';

const rule = {
	name: 'alphanumeric',
	method ({ message } = { message: 'Letters, numbers, spaces or underscores only please' }) {

		return this.test('alphanumeric', message, function (value) {

			const { createError } = this;
			return /^[\w ]+$/i.test(value) || createError({ message });

		});

	},
	schemaType: string
};

export default rule;
